<template>
	<v-app-bar id="app-bar" color="white" app fixed flat>
		<v-btn
			class="mr-3"
			elevation="1"
			fab
			small
			@click.stop="drawer = !drawer"
		>
			<v-icon v-if="drawerState" style="display: table-cell"
				>mdi-dots-vertical</v-icon
			>
			<v-icon v-else style="display: table-cell">mdi-menu</v-icon>
		</v-btn>
		<v-btn
			class="d-none d-sm-block ml-3"
			elevation="0"
			fab
			small
			@click.stop="$router.go(-1)"
		>
			<v-icon style="display: table-cell">mdi-arrow-left</v-icon>
		</v-btn>
		<v-breadcrumbs class="d-none d-sm-block" :items="breadCrumbs">
			<template v-slot:item="{ item }">
				<v-breadcrumbs-item :to="item.Path" :disabled="item.Disabled">
					<breadcrumb-dropdown
						v-if="item.Children"
						:item="item"
						:pageName="pageName"
					></breadcrumb-dropdown>
					<span v-else>{{ item.Title }}</span>
				</v-breadcrumbs-item>
			</template>
		</v-breadcrumbs>
		<v-spacer />
		<notifications />
		<v-btn text :to="profile.to">
			<v-icon class="mr-2">mdi-account</v-icon>
			{{ profile.title }}
		</v-btn>
		<v-btn min-width="0" title="Logout" text @click.prevent="logout">
			<v-icon>mdi-logout</v-icon>
		</v-btn>
	</v-app-bar>
</template>

<script>
import { AuthActionTypes, GeneralActions } from '../../store/actions';
import { AuthGetterTypes, GeneralGetters } from '../../store/getters';
import { mapGetters } from 'vuex';
import BreadcrumbDropdown from './BreadcrumbDropdown.vue';
import Notifications from '@/components/layout/components/Notifications';
import { routesNames } from '../../enums/routesNames';
import { GridsGetters, InventoryFormGetters } from '@/store/getters';
import { InventoryFormTypes } from '../../enums/inventoryFormTypes';

export default {
	name: 'LayoutAppBar',
	components: {
		Notifications,
		BreadcrumbDropdown,
	},
	data() {
		return { menuStatus: false };
	},
	computed: {
		...mapGetters({
			drawerState: [GeneralGetters.DRAWER],
			user: [AuthGetterTypes.CURRENT_USER],
			gridsMenuEntities: [GridsGetters.GET_MENU_ENTITIES],
			inventoryFormsMenuEntities: [InventoryFormGetters.MENU_FORMS],
		}),
		profile() {
			let title = '';
			if (this.user && this.user.firstName && this.user.lastName)
				title = `${this.user.firstName} ${this.user.lastName}`;

			return {
				avatar: true,
				to: '/myprofile',
				title: title,
			};
		},
		pageName() {
			let pageName = this.getGridPageName();
			if (this.$route.params.formId) {
				if (
					this.inventoryFormsMenuEntities.find(
						(x) => x.Id == this.$route.params.formId
					)
				)
					pageName = this.inventoryFormsMenuEntities.find(
						(x) => x.Id == this.$route.params.formId
					).Name;
			}
			return pageName;
		},
		breadCrumbs() {
			let result = [{ Title: 'Homepage', Path: '/homepage' }];
			if (this.$route.path.includes('/grids/')) {
				result.push({ Title: 'Datasets', Path: null, Disabled: true });
				result.push(this.getDatasetEntities());
			}
			if (
				[
					routesNames.INVENTORY,
					routesNames.INVENTORY_GRID,
					routesNames.INVENTORY_FORM,
					routesNames.INVENTORY_FORM_HISTORY,
				].includes(this.$route.name)
			) {
				result.push({ Title: 'Inventory', Path: null, Disabled: true });
				result.push(this.getInventoryEntities());
			}
			if (this.$route.path.includes('/tools/')) {
				result.push({ Title: 'Tools', Path: null, Disabled: true });
				result.push(this.toolsItems());
			}
			if (this.$route.path.includes('/settings/')) {
				result.push({ Title: 'Settings', Path: null, Disabled: true });
				result.push(this.settingsItems());
			}
			switch (this.$route.name) {
				case routesNames.SCHEDULE:
					result.push({ Title: 'Schedule', Path: '/schedule' });
					break;
				case routesNames.DATASETS_HISTORY:
					result.push({
						Title: 'History',
						Path: {
							name: routesNames.DATASETS_GRIDS,
							params: { pageName: this.pageName },
						},
					});
					break;
				case routesNames.DATASETS_RECORD_HISTORY:
					result.push({
						Title: 'History',
						Path: {
							name: routesNames.DATASETS_GRIDS,
							params: { pageName: this.pageName },
						},
					});
					break;
				case routesNames.DATASETS_EDIT:
					result.push({ Title: 'Edit', Path: null, Disabled: true });
					break;
				case routesNames.DATASETS_ADD:
					result.push({
						Title: 'Add',
						Path: { name: routesNames.DATASETS_ADD },
					});
					break;
				case routesNames.INVENTORY_GRID:
					result.push({
						Title: 'Grid',
						Children: [
							{
								Title: 'Form',
								Path: {
									name: routesNames.INVENTORY_FORM,
									params: {
										formId: this.$route.params.formId,
									},
								},
							},
							{
								Title: 'Grid',
								Path: {
									name: routesNames.INVENTORY_GRID,
									params: {
										formId: this.$route.params.formId,
									},
								},
							},
						],
					});
					break;
				case routesNames.INVENTORY_FORM:
					result.push({
						Title: 'Form',
						Children: [
							{
								Title: 'Form',
								Path: {
									name: routesNames.INVENTORY_FORM,
									params: {
										formId: this.$route.params.formId,
									},
								},
							},
							{
								Title: 'Grid',
								Path: {
									name: routesNames.INVENTORY_GRID,
									params: {
										formId: this.$route.params.formId,
									},
								},
							},
						],
					});
					break;
				case routesNames.INVENTORY_FORM_HISTORY:
					result.push({
						Title: this.getInventoryType(),
						Children: [
							{
								Title: 'Form',
								Path: {
									name: routesNames.INVENTORY_FORM,
									params: {
										formId: this.$route.params.formId,
									},
								},
							},
							{
								Title: 'Grid',
								Path: {
									name: routesNames.INVENTORY_GRID,
									params: {
										formId: this.$route.params.formId,
									},
								},
							},
						],
					});
					result.push({
						Title: 'History',
						Path: {
							name: routesNames.INVENTORY_FORM_HISTORY,
							params: { formId: this.$route.params.formId },
						},
					});
					break;
				case routesNames.REPORTS:
					result.push({
						Title: 'Reports',
						Path: { name: routesNames.REPORTS },
					});
					break;
				case routesNames.REPORT_GRID:
					result.push({
						Title: 'Reports',
						Path: { name: routesNames.REPORTS },
					});
					result.push({
						Title: 'Report Grid',
						Path: {
							name: routesNames.REPORT_GRID,
							params: {
								reportId: this.$route.params.reportId,
								gridViewId: this.$route.params.gridViewId,
							},
						},
					});
					break;
				case routesNames.REPORT_GRID_CUSTOM:
					result.push({
						Title: 'Reports',
						Path: { name: routesNames.REPORTS },
					});
					result.push({
						Title: 'Report Grid',
						Path: {
							name: routesNames.REPORT_GRID_CUSTOM,
							params: { reportId: this.$route.params.reportId },
						},
					});
					break;
				case routesNames.REPORT_WORKBOOK:
					result.push({
						Title: 'Reports',
						Path: { name: routesNames.REPORTS },
					});
					result.push({
						Title: 'Workbook',
						Path: {
							name: routesNames.REPORT_WORKBOOK,
							params: {
								workbookId: this.$route.params.workbookId,
							},
						},
					});
					break;
				case routesNames.EDIT_INVENTORY_FORM:
					result.push({
						Title: 'Edit',
						Path: {
							name: routesNames.EDIT_INVENTORY_FORM,
							params: { id: this.$route.params.id },
						},
					});
					break;
				case routesNames.ADD_INVENTORY_FORM:
					result.push({
						Title: 'Add',
						Path: { name: routesNames.ADD_INVENTORY_FORM },
					});
					break;
				case routesNames.DATA_IMPORT_TEMPLATES:
					result.push({
						Title: 'Templates',
						Path: { name: routesNames.DATA_IMPORT_TEMPLATES },
					});
					break;
				case routesNames.USER_MANAGEMENT_ADMIN_EDIT:
					result.push({
						Title: 'Edit',
						Path: {
							name: routesNames.USER_MANAGEMENT_ADMIN_EDIT,
							params: { id: this.$route.params.id },
						},
					});
					break;
				case routesNames.USER_MANAGEMENT_ADMIN_ADD:
					result.push({
						Title: 'Add',
						Path: { name: routesNames.USER_MANAGEMENT_ADMIN_ADD },
					});
					break;
				case routesNames.USER_MANAGEMENT_CLIENT_EDIT:
					result.push({
						Title: 'Edit',
						Path: {
							name: routesNames.USER_MANAGEMENT_CLIENT_EDIT,
							params: { id: this.$route.params.id },
						},
					});
					break;
				case routesNames.USER_MANAGEMENT_CLIENT_ADD:
					result.push({
						Title: 'Add',
						Path: { name: routesNames.USER_MANAGEMENT_CLIENT_ADD },
					});
					break;
				case routesNames.REPORT_DETAILS:
					if (this.$route.params.workbookId)
						result.push({
							Title: 'Report Details',
							Path: {
								name: routesNames.REPORT_DETAILS,
								params: {
									reportId: this.$route.params.reportId,
								},
							},
						});
					else
						result.push({
							Title: 'Report Details',
							Path: { name: routesNames.REPORT_DETAILS },
						});
					break;
				case routesNames.WORKBOOK_DETAILS:
					if (this.$route.params.workbookId)
						result.push({
							Title: 'Workbook Details',
							Path: {
								name: routesNames.WORKBOOK_DETAILS,
								params: {
									reportId: this.$route.params.workbookId,
								},
							},
						});
					else
						result.push({
							Title: 'Workbook Details',
							Path: { name: routesNames.WORKBOOK_DETAILS },
						});
					break;
				case routesNames.CLIENTS:
					result.push({
						Title: 'Clients',
						Path: { name: routesNames.CLIENTS },
					});
					break;
				case routesNames.CLIENTS_EDIT:
					result.push({
						Title: 'Clients',
						Path: { name: routesNames.CLIENTS },
					});
					result.push({
						Title: 'Edit',
						Path: {
							name: routesNames.CLIENTS_EDIT,
							params: { id: this.$route.params.id },
						},
					});
					break;
				case routesNames.CLIENTS_ADD:
					result.push({
						Title: 'Clients',
						Path: { name: routesNames.CLIENTS },
					});
					result.push({
						Title: 'Add',
						Path: { name: routesNames.CLIENTS_ADD },
					});
					break;
				case routesNames.PROJECTS:
					result.push({
						Title: 'Projects',
						Path: { name: routesNames.PROJECTS },
					});
					break;

				case routesNames.PROJECTS_EDIT:
					result.push({
						Title: 'Projects',
						Path: { name: routesNames.PROJECTS },
					});
					result.push({
						Title: 'Edit',
						Path: {
							name: routesNames.PROJECTS_EDIT,
							params: { id: this.$route.params.id },
						},
					});
					break;
				case routesNames.PROJECTS_ADD:
					result.push({
						Title: 'Projects',
						Path: { name: routesNames.PROJECTS },
					});
					result.push({
						Title: 'Add',
						Path: { name: routesNames.PROJECTS_ADD },
					});
					break;
			}
			return result;
		},
		drawer: {
			get() {
				return this.drawerState;
			},
			set(isToggled) {
				this.$store.dispatch(
					GeneralActions.UPDATE_DRAWER_STATE,
					isToggled
				);
			},
		},
	},
	methods: {
		toolsItems() {
			let page = '';
			switch (this.$route.name) {
				case routesNames.FORM_BUILDER:
				case routesNames.EDIT_INVENTORY_FORM:
				case routesNames.ADD_INVENTORY_FORM:
					page = 'Form Builder';
					break;
				case routesNames.ACTIVITY_BUILDER:
				case routesNames.ADD_ACTIVITY:
				case routesNames.EDIT_ACTIVITY:
					page = 'Activity Builder';
					break;
				case routesNames.REPORT_BUILDER:
				case routesNames.REPORT_DETAILS:
				case routesNames.WORKBOOK_DETAILS:
					page = 'Report Builder';
					break;
				case routesNames.DATA_IMPORT:
				case routesNames.DATA_IMPORT_TEMPLATES:
					page = 'Data Import';
					break;
				case routesNames.DATA_EXPORT:
					page = 'Data Exports';
					break;
				case routesNames.USER_MANAGEMENT:
				case routesNames.USER_MANAGEMENT_ADMIN_EDIT:
				case routesNames.USER_MANAGEMENT_ADMIN_ADD:
				case routesNames.USER_MANAGEMENT_CLIENT_EDIT:
				case routesNames.USER_MANAGEMENT_CLIENT_ADD:
					page = 'User Management';
					break;
				case routesNames.PROJECT_CLONE:
					page = 'Clone Project';
					break;
			}
			return {
				Title: page,
				Children: [
					{
						Title: 'Activity Builder',
						Path: { name: routesNames.ACTIVITY_BUILDER },
					},
					{
						Title: 'Form Builder',
						Path: { name: routesNames.FORM_BUILDER },
					},
					{
						Title: 'Report Builder',
						Path: { name: routesNames.REPORT_BUILDER },
					},
					{
						Title: 'Data Import',
						Path: { name: routesNames.DATA_IMPORT },
					},
					{
						Title: 'Data Exports',
						Path: { name: routesNames.DATA_EXPORT },
					},
					{
						Title: 'User Management',
						Path: { name: routesNames.USER_MANAGEMENT },
					},
					{
						Title: 'Clone Project',
						Path: { name: routesNames.PROJECT_CLONE },
					},
				].sort((a, b) => (a.Title > b.Title ? 1 : -1)),
			};
		},
		settingsItems() {
			let page = '';
			switch (this.$route.name) {
				case routesNames.GENERAL_SETTINGS:
					page = 'General Settings';
					break;
				case routesNames.DATABASE_TABLES:
					page = 'Database Tables';
					break;
				case routesNames.REFERENCE_LISTS:
					page = 'Reference List';
					break;
				case routesNames.DATASET_FIELDS:
					page = 'Dataset Fields';
					break;
				case routesNames.MERGE_CONDITIONS:
					page = 'Merge Conditions';
					break;
				case routesNames.CONNECTORS:
					page = 'Connectors';
					break;
			}
			return {
				Title: page,
				Children: [
					{
						Title: 'General Settings',
						Path: { name: routesNames.GENERAL_SETTINGS },
					},
					{
						Title: 'Database Tables',
						Path: { name: routesNames.DATABASE_TABLES },
					},
					{
						Title: 'Reference List',
						Path: { name: routesNames.REFERENCE_LISTS },
					},
					{
						Title: 'Dataset Fields',
						Path: { name: routesNames.DATASET_FIELDS },
					},
					{
						Title: 'Merge Conditions',
						Path: { name: routesNames.MERGE_CONDITIONS },
					},
					{
						Title: 'Connectors',
						Path: { name: routesNames.CONNECTORS },
					},
				].sort((a, b) => (a.Title > b.Title ? 1 : -1)),
			};
		},
		getInventoryEntities() {
			let result = { Title: this.pageName, Children: [] };
			this.inventoryFormsMenuEntities
				.sort((a, b) => (a.Name > b.Name ? 1 : -1))
				.forEach((e) => {
					if (this.getInventoryType() == 'Grid')
						result.Children.push({
							Title: e.Name,
							Path: {
								name: routesNames.INVENTORY_GRID,
								params: { formId: e.Id },
							},
						});
					if (this.getInventoryType() == 'Form')
						result.Children.push({
							Title: e.Name,
							Path: {
								name: routesNames.INVENTORY_FORM,
								params: { formId: e.Id },
							},
						});
				});
			return result;
		},
		getDatasetEntities() {
			let result = { Title: this.pageName, Children: [] };
			this.gridsMenuEntities
				.sort((a, b) => (a.Name > b.Name ? 1 : -1))
				.forEach((e) =>
					result.Children.push({
						Title: e.Name,
						Path: {
							name: routesNames.DATASETS_GRIDS,
							params: { pageName: e.Name },
						},
					})
				);
			return result;
		},
		getInventoryType() {
			let currentInventory = null;
			if (this.$route.params.formId)
				currentInventory = this.inventoryFormsMenuEntities.find(
					(x) => x.Id == this.$route.params.formId
				);
			if (currentInventory)
				switch (currentInventory.Type) {
					case InventoryFormTypes.Inventory:
						return 'Form';
					case InventoryFormTypes.SteadyState:
						return 'Grid';
				}
			return currentInventory;
		},
		getGridPageName() {
			let pageName = '';
			if (this.$route.params.pageName) {
				pageName = this.$route.params.pageName.replace(/([-_.])/g, ' ');
				pageName = pageName.replace(/^[a-zA-Z]/, (x) =>
					x.toUpperCase()
				);
			}
			return pageName;
		},
		toggleDropdown() {
			if (this.menuStatus) this.menuStatus = false;
			else this.menuStatus = true;
		},
		logout() {
			this.$store.dispatch(AuthActionTypes.LOGOUT).then(() => {
				this.$router.push('/login');
				global.queue.clear();
			});
		},
	},
};
</script>
